























import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class BaseInfoPanelWithBadge extends Vue {
    @Prop({
        default: '',
    })
    public icon: string;
    @Prop({
        default: '',
    })
    public title: string;
    @Prop({
        default: '',
    })
    public description: string;
    public created() {}
    public mounted() {}
}
